import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import MeasurementTableDto from '../dto/MeasurementTableDto';

class MeasurementTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'measurementTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<MeasurementTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, MeasurementTableDto)))
				.catch(reject);
		});
	}

	/**
	 * @param {string} session
	 * @return {Promise<Object>}
	 */
	deleteSelected(session) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/deleteSelected`, {
					session
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<Object>}
	 */
	findEdaTypesByMeasurement(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/findEdaTypesByMeasurement`, {
					id
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {string} session
	 * @return {Promise<Object>}
	 */
	findEdaTypesBySession(session) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/findEdaTypesBySession`, {
					session
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<Object>}
	 */
	downloadCsv(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/downloadCsv`, {
					id
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {{ start: Date|null, end: Date|null }} ts
	 * @param {number[]} values
	 * @return {Promise<any>}
	 */
	getData(id, ts, values) {
		const payload = {
			id,
			ts,
			values
		};

		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, payload)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	* @param {number} id
	* @return {Promise<any>}
	*/
	getTimeseriesDetails(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getTimeseriesDetails`, {
					id
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new MeasurementTableService();
